import { designSystemColors } from '@klv/shared/styles/colors';

const DynamicTextFormField = { 
  addButtonColor: designSystemColors.charcoal,
};

export default DynamicTextFormField;
